import React from 'react'
import styled from '@emotion/styled'

const Root = styled.div`
  padding: ${({noLeftPadding}) => noLeftPadding ? '25px 25px 25px 0' : '25px'};
  color: #ec2323;
  font-size: 16px;
  font-weight: 500;
`

const Error = ({message, noLeftPadding}) => <Root noLeftPadding={noLeftPadding}>
  {message ? message : 'Произошла ошибка. Пожалуйста, попробуйте обновить страницу или зайдите позже.'}
</Root>

export default Error
